/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_errors_404_title = /** @type {(inputs: {}) => string} */ () => {
	return `Stránka nebyla nalezena`
};

const da_errors_404_title = /** @type {(inputs: {}) => string} */ () => {
	return `Siden blev ikke fundet`
};

const de_errors_404_title = /** @type {(inputs: {}) => string} */ () => {
	return `Seite nicht gefunden`
};

const en_errors_404_title = /** @type {(inputs: {}) => string} */ () => {
	return `Page not found`
};

const es_errors_404_title = /** @type {(inputs: {}) => string} */ () => {
	return `Página no encontrada`
};

const fr_errors_404_title = /** @type {(inputs: {}) => string} */ () => {
	return `Page non trouvée`
};

const hu_errors_404_title = /** @type {(inputs: {}) => string} */ () => {
	return `Az oldal nem található`
};

const it_errors_404_title = /** @type {(inputs: {}) => string} */ () => {
	return `Pagina non trovata`
};

const nl_errors_404_title = /** @type {(inputs: {}) => string} */ () => {
	return `Pagina niet gevonden`
};

const pl_errors_404_title = /** @type {(inputs: {}) => string} */ () => {
	return `Nie znaleziono strony`
};

const pt_errors_404_title = /** @type {(inputs: {}) => string} */ () => {
	return `Página não encontrada`
};

const sv_errors_404_title = /** @type {(inputs: {}) => string} */ () => {
	return `Sidan hittades inte`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const errors_404_title = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.errors_404_title(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("errors_404_title", locale)
	if (locale === "cs") return cs_errors_404_title(inputs)
	if (locale === "da") return da_errors_404_title(inputs)
	if (locale === "de") return de_errors_404_title(inputs)
	if (locale === "en") return en_errors_404_title(inputs)
	if (locale === "es") return es_errors_404_title(inputs)
	if (locale === "fr") return fr_errors_404_title(inputs)
	if (locale === "hu") return hu_errors_404_title(inputs)
	if (locale === "it") return it_errors_404_title(inputs)
	if (locale === "nl") return nl_errors_404_title(inputs)
	if (locale === "pl") return pl_errors_404_title(inputs)
	if (locale === "pt") return pt_errors_404_title(inputs)
	return sv_errors_404_title(inputs)
};
export { errors_404_title as "errors.404.title" }